import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import { apiPost } from "../utils/api";

export default function Chat() {
  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState(null);
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      const wano = sessionStorage.getItem("wano") || "919716167415";
      const data = await apiPost("/customers/GetCustomerList", { wano });
      setContacts(data);
    } catch (err) {
      console.error("Failed to load customer list", err);
    }
  };

  const openChat = async (c) => {
    setSelected(c);
    setMessages([]);

    try {
      const userId = sessionStorage.getItem("username");
      const wano = sessionStorage.getItem("wano") || "919716167415";
      const data = await apiPost("/customers/GetChatHistory", {
        Wano: wano,     
        UserId: userId,
        CustomerNumber: c.mobileNumber
      });

      const uiMessages = data.map(m => ({
        from: m.direction === "out" ? "me" : "customer",
        text: m.message,
        time: new Date(m.timestamp).toLocaleTimeString()
      }));

      setMessages(uiMessages);
    }
    catch (err) {
      console.error("Failed to load chat history", err);
    }
  };


  const sendMessage = () => {
    if (!text.trim() || !selected) return;

    setMessages((m) => [
      ...m,
      { from: "me", text, time: new Date().toLocaleTimeString() }
    ]);

    setText("");
  };

  const getInitial = (name, number) => {
    if (name && name.trim().length > 0) {
      return name.trim().charAt(0).toUpperCase();
    }

    if (number && number.length > 0) {
      // For numbers like 919716167415 → 9
      // For ids like 219859845644518@lid → 2
      return number.replace(/[^a-zA-Z0-9]/g, "").charAt(0).toUpperCase();
    }

    return "?";
  };

  return (
    <>
      <Navbar />
      <div className="page-container" style={{ display: "flex", gap: "20px", height: "calc(100vh - 120px)", overflow: "hidden" }}>
        {/* Contacts */}
        <div className="card" style={{ width: "340px", padding: "10px", height: "100%", overflowY: "auto", boxSizing: "border-box" }}>
          <h3 className="section-title">Chats</h3>

          {contacts.map((c) => (
            <div
              key={c.mobileNumber}
              onClick={() => openChat(c)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px",
                cursor: "pointer",
                borderRadius: "10px",
                background:
                  selected?.mobileNumber === c.mobileNumber ? "#e8f5e9" : "transparent"
              }}
            >
              {/* Avatar */}
              <div
                style={{
                  width: "45px",
                  height: "45px",
                  borderRadius: "50%",
                  background: "#25D366",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  fontWeight: "bold"
                }}
              >
                {getInitial(c.profileName, c.mobileNumber)}
              </div>

              {/* Name + Last message */}
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: "bold" }}>
                  {c.profileName || "Unknown"}{" "}
                  <span style={{ fontSize: "12px", color: "#666" }}>
                    ({c.mobileNumber})
                  </span>
                </div>

                <div style={{ fontSize: "12px", color: "#666" }}>
                  {c.lastMessage
                    ? (c.lastMessage || "").substring(0, 30)
                    : ""}
                </div>
              </div>

              {/* Time */}
              <div style={{ fontSize: "11px", color: "#999" }}>
                {c.receivedAt
                  ? new Date(c.receivedAt).toLocaleTimeString()
                  : ""}
              </div>
            </div>
          ))}
        </div>

        {/* Chat Window */}
        <div
          className="card"
          style={{ flex: 1, display: "flex", flexDirection: "column", height: "100%", boxSizing: "border-box" }}
        >
          <div
            style={{
              borderBottom: "1px solid #ddd",
              paddingBottom: "10px",
              fontWeight: "bold"
            }}
          >
            {selected
              ? `${selected.profileName || "Unknown"} (${selected.mobileNumber})`
              : "Select a chat"}
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: "10px" }}>
            {messages.length === 0 && selected && (
              <div style={{ color: "#999" }}>No messages yet</div>
            )}

            {messages.map((m, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent: m.from === "me" ? "flex-end" : "flex-start",
                  marginBottom: "10px",
                  paddingRight: m.from === "me" ? "0" : "20px",
                  paddingLeft: m.from === "me" ? "20px" : "0"
                }}
              >
                <div
                  style={{
                    background: m.from === "me" ? "#dcf8c6" : "#e8e8e8",
                    padding: "10px 14px",
                    borderRadius: "12px",
                    display: "inline-block",
                    maxWidth: "65%",
                    wordWrap: "break-word",
                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <div style={{ fontSize: "14px", color: "#333", marginBottom: "4px" }}>
                    {m.text}
                  </div>
                  <div style={{ fontSize: "11px", color: "#999" }}>
                    {m.time}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {selected && (
            <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
              <input
                className="input-field"
                value={text}
                onChange={(e) => setText(e.target.value)}
                placeholder="Type a message..."
              />
              <button className="button" onClick={sendMessage}>
                Send
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
